import classes from "./toast.module.css";

import React, { useCallback } from "react";

import { vars as styleVars } from "@app/styles";
import { notification } from "@honeycomb/ui";
import { Bell, Bug, TriangleAlert } from "lucide-react";

export enum ToastTypes {
  info,
  warn,
  error,
}

export type ToastProps = {
  type: keyof typeof ToastTypes;
  title: string | Element | JSX.Element;
  message: string | Element | JSX.Element;
  duration?: number;
};

export const Toast = ({ type, title, message, duration = 5 }: ToastProps) => {
  const key = new Date().valueOf().toString();
  let icon: JSX.Element;

  switch (type) {
    case "error":
      icon = <Bug color={styleVars.colorRed} />;
      break;
    case "info":
      icon = <Bell color={styleVars.colorPrimary} />;
      break;
    case "warn":
      icon = <TriangleAlert color={styleVars.colorGold} />;
      break;
  }

  const handleClose = useCallback(() => {
    notification.close(key);
  }, [key]);

  notification.open({
    key,
    icon: icon && <div className={classes["icon"]}>{icon}</div>,
    message: <div className={classes["title"]}>{title}</div>,
    description: (
      <div className={classes["message"]}>
        {message}
        <div>
          <button onClick={handleClose}>Close</button>
        </div>
      </div>
    ),
    placement: "bottomLeft",
    duration,
  });
};
